<!-- Page intro -->
<section class="sw-intro" id="software-overview">
  <div class="sw-container">
    <p class="sw-kicker">Software and Service</p>
    <h1 class="sw-page-title">NTRIP service and RTK software</h1>
    <p class="sw-page-subtitle">
      Cloud NTRIP correction services, PPK toolkits, and an iOS BLE-GNSS app for professional centimeter-level workflows.
    </p>
    <div class="sw-jump">
      <button type="button" class="sw-jump-chip" (click)="scrollTo('software-ntrip')">NTRIP Caster</button>
      <button type="button" class="sw-jump-chip" (click)="scrollTo('software-rtk-expert')">RTK Expert</button>
      <button type="button" class="sw-jump-chip" (click)="scrollTo('software-ble-gnss')">BLE-GNSS iOS App</button>
    </div>
  </div>
</section>

<!-- NTRIP Caster -->
<section class="sw-product" id="software-ntrip">
  <div class="sw-container">
    <div class="sw-split">
      <div class="sw-copy">
        <p class="sw-product-kicker">NTRIP Service</p>
        <h2 class="sw-product-title">GeoAstra NTRIP Caster 2.0</h2>
        <p class="sw-product-lead">
          Transform your RTK base into your own CORS service—stream corrections over NTRIP with cloud management.
        </p>
        <ul class="sw-specs">
          <li>Cloud NTRIP caster for your own base network</li>
          <li>Centimeter-level RTK correction delivery</li>
          <li>Mountpoints, users, and connection monitoring</li>
          <li>Works with GeoAstra receivers and third-party rovers</li>
        </ul>
        <div class="sw-actions">
          <button type="button" class="btn btn-outline-secondary px-4" (click)="loginNtripCaster()">Login</button>
          <button type="button" class="btn btn-primary px-4" (click)="goToNtripCasterLearnMore()">Learn more</button>
        </div>
      </div>
      <div class="sw-media">
        <img
          src="assets/images/landing/GeoAstra_NTRIP.png"
          class="sw-product-img lnc-zoom-img"
          alt="GeoAstra NTRIP Caster"
          loading="eager"
          (click)="openLightbox('assets/images/landing/GeoAstra_NTRIP.png','GeoAstra NTRIP Caster')"
        >
      </div>
    </div>
  </div>
</section>

<!-- RTK Expert -->
<section class="sw-product sw-product--alt" id="software-rtk-expert">
  <div class="sw-container">
    <div class="sw-split sw-split--reverse">
      <div class="sw-copy">
        <p class="sw-product-kicker">RTK Software</p>
        <h2 class="sw-product-title">GeoAstra RTK Expert 1.0</h2>
        <p class="sw-product-lead">
          A toolkit for simplified PPK data processing workflows—from download to centimeter-level solutions.
        </p>
        <ul class="sw-specs">
          <li>PPK processing made practical for field teams</li>
          <li>Streamlined data download and workflow tools</li>
          <li>Designed for high-accuracy post-processing</li>
          <li>Complements GeoAstra NTRIP and receivers</li>
        </ul>
        <div class="sw-actions">
          <button type="button" class="btn btn-outline-secondary px-4" (click)="loginRtkExpert()">Login</button>
          <button type="button" class="btn btn-primary px-4" (click)="goToRtkExpertLearnMore()">Learn more</button>
        </div>
      </div>
      <div class="sw-media">
        <img
          src="assets/images/landing/GeoAstra_PPK_Studio_small.png"
          class="sw-product-img lnc-zoom-img"
          alt="GeoAstra RTK Expert / PPK Studio"
          loading="lazy"
          (click)="openLightbox('assets/images/landing/GeoAstra_PPK_Studio_small.png','GeoAstra RTK Expert')"
        >
      </div>
    </div>
  </div>
</section>

<!-- BLE-GNSS iOS App -->
<section class="sw-product" id="software-ble-gnss">
  <div class="sw-container">
    <div class="sw-split">
      <div class="sw-copy">
        <p class="sw-product-kicker">iOS RTK Software</p>
        <h2 class="sw-product-title">GeoAstra BLE-GNSS iOS App</h2>
        <p class="sw-product-lead">
          Connect compatible Bluetooth RTK GNSS receivers to iPhone and iPad for centimeter-level field positioning.
        </p>
        <ul class="sw-specs">
          <li>RTK Rover and portable RTK Base workflows from iOS</li>
          <li>Local NMEA sharing with compatible iOS field apps</li>
          <li>Point and track collection, stakeout, playback, and export</li>
          <li>Free to download from the Apple App Store</li>
        </ul>
        <div class="sw-actions">
          <a
            class="btn btn-outline-secondary px-4"
            href="https://apps.apple.com/us/app/geoastra-ble-gnss/id6794132781"
            target="_blank"
            rel="noopener"
          >Download on the App Store</a>
          <a
            class="btn btn-primary px-4"
            href="https://gpswebshop.com/products/geoastra-ble-gnss-ios-rtk-app"
            target="_blank"
            rel="noopener"
          >Learn more</a>
        </div>
      </div>
      <div class="sw-media">
        <img
          src="assets/images/landing/GeoAstra_BLE_GNSS_iOS_3D.jpg"
          class="sw-product-img lnc-zoom-img"
          alt="GeoAstra BLE-GNSS iOS App connecting a GNSS receiver to an iOS device"
          loading="lazy"
          (click)="openLightbox('assets/images/landing/GeoAstra_BLE_GNSS_iOS_3D.jpg','GeoAstra BLE-GNSS iOS App')"
        >
      </div>
    </div>
  </div>
</section>

<!-- Lightbox overlay -->
<div *ngIf="lightboxOpen" class="lightbox-backdrop" (click)="closeLightbox()">
  <div class="lightbox-content" (click)="$event.stopPropagation()">
    <button type="button" class="btn-close lightbox-close" aria-label="Close" (click)="closeLightbox()"></button>
    <img [src]="lightboxSrc" [alt]="lightboxAlt" class="img-fluid w-100" />
  </div>
</div>
